module.exports = __webpack_public_path__ + "static/media/mono-genoma.cbcd5053.png";